<template>
  <div class="change-password-container">
    <h2>Change Password</h2>
    <p class="subtitle">
      Please enter your current password to change password
    </p>

    <form class="form">
      <div class="form-group">
        <label>Current Password</label>
        <input type="password" v-model="currentPassword" placeholder="Olivia" />
      </div>

      <div class="form-group">
        <label>Enter New Password</label>
        <input type="password" v-model="newPassword" placeholder="Olivia" />
      </div>

      <div class="form-group">
        <label>Re-enter New Password</label>
        <input type="password" v-model="confirmPassword" placeholder="Olivia" />
      </div>

      <div class="button-group">
        <button type="button" class="cancel-btn">Cancel</button>
        <button
          type="submit"
          class="change-btn"
          @click.prevent="savePasswordChanges"
        >
          Change Password
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import "../../../public/css/main.css";

export default {
  name: "ChangePassword",
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    };
  },
  methods: {
    async savePasswordChanges() {
      if (this.newPassword !== this.confirmPassword) {
        alert("❌ Passwords do not match!");
        this.newPassword = "";
        this.confirmPassword = "";
        return;
      }

      const userId = localStorage.getItem("userid");

      try {
        // 2. Verify current password server-side (the stored password is never
        // sent to the browser).
        const verifyRes = await axios.post("/api/verify-password", {
          userID: userId,
          password: this.currentPassword,
        });

        // 3. Validate current password
        if (!verifyRes.data?.valid) {
          alert("❌ Current password is wrong!");
          this.currentPassword = "";
          return;
        }

        // 4. Update new password
        await axios.put("/api/updateoneuser", {
          userID: userId,
          password: this.confirmPassword,
        });

        alert("✅ Password changed successfully!");
        this.currentPassword = "";
        this.newPassword = "";
        this.confirmPassword = "";
      } catch (error) {
        console.error("Error updating password:", error.message || error);
        alert("Something went wrong. Please try again.");
      }
    },
  },
};
</script>

<style scoped>
.change-password-container {
  width: 100%;
  max-width: 646px;
  margin: auto;
  background: #fff;
  border-radius: 16px;
  padding: 32px 40px;
  font-family: "Inter", sans-serif;
  margin-top: 50px;
}

h2 {
  font-size: 24px;
  font-weight: 600;
  color: #181d27;
  line-height: 32px;
  font-family: var(--font-primary);
  margin: 0px !important;
}

.subtitle {
  color: #535862;
  font-size: 14px;
  margin-bottom: 24px;
  font-family: var(--font-primary);
  font-weight: var(--weight-regular);
  font-size: 14px;
  line-height: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
}

label {
  font-size: 14px;
  color: #414651;
  margin-bottom: 6px;
}

input {
  padding: 10px 14px;
  border: 1px solid #d5d7da;
  border-radius: 8px;
  font-size: 14px;
  outline: none;
}

input:focus {
  /* border-color: #2563eb;
  box-shadow: 0 0 0 1px #2563eb; */
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 10px;
}

.cancel-btn {
  background: transparent;
  border: 1px solid #d5d7da;
  color: #374151;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  font-family: var(--font-primary);
  line-height: 20px;
  font-size: 14px;
}

.cancel-btn:hover {
  background: #f9fafb;
}

.change-btn {
  background: #3467d5;
  color: #ffffff;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 600;
  border: 1px solid #3467d5;
  font-family: var(--font-primary);
  line-height: 20px;
  font-size: 14px;
}

.change-btn:hover {
  background: #1e40af;
}
@media (max-width: 480px) {
  .change-password-container {
    padding: 0px !important;
  }
}
</style>
